import Drafts from "./Drafts"
import { Props as DraftProps } from "./Item"

export interface Props {
  drafts: DraftProps[]
  hasAdditionalInstructions?: boolean
  isAdmin?: boolean
  isEditor?: boolean
}

export interface ComponentProps extends Props {}

export default Drafts
